export default __webpack_public_path__ + "static/media/TC-Glamstar.2022.v4-09.2022.8d11673b.pdf";